import { ContratadaHttp } from "gateways/repo/contratada_http_client";
import { useState } from "react";
import { OptionsModel } from "shared/models/contratada_response.model";
import { setContratadaOptions } from "store/contratada/contratada_slice";
import { useAppDispatch } from "store/store";
import { formatToOption } from "utils/enumListToOptions";

const useContratada = () => {
  const http = new ContratadaHttp();
  const dispatch = useAppDispatch();
  const [isLoadingConrtatada, setLoading] = useState(false);
  const [contratadaOptions, setContratadaOption] = useState<OptionsModel[]>([]);

  const getContratada = async () => {
    setLoading(true);
    try {
      const data = await http.getListContratada();
      let options: OptionsModel[] = [];
      data.Lista.forEach(val => {
        options.push(formatToOption(val.ID.toString(), val.RazaoSocial));
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getContratadaOption = async () => {
    setLoading(true);
    try {
      const data = await http.getListContratadaOptions();
      let options: OptionsModel[] = [];
      data.Lista.forEach(val => {
        options.push(formatToOption(val.ID.toString(), val.Text));
      });

      setContratadaOption(options);
      dispatch(setContratadaOptions(options));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const formatOption = (id: number, name: string) => {
    return { value: id.toString(), label: name };
  };
  return {
    isLoadingConrtatada,
    contratadaOptions,
    getContratada,
    getContratadaOption,
  };
};
export default useContratada;
